module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1169.2aa1159d.png";